import { subtract, sum } from "lodash";
import FormulaLayoutUI from "../../../layoutComponents/TextfieldFormulaUI/FormulaLayoutUI";


const TransporterBalanceAmount = ({ total, advance, freightDeduction, tdsDeduction }) => {
  const balance = subtract(Number(total ?? 0), Number(sum([Number(advance ?? 0), Number(freightDeduction ?? 0), Number(tdsDeduction ?? 0)]) ?? 0)).toFixed(2); 
  return (
    <FormulaLayoutUI>
      <strong>Balance Amount Formula:</strong>
      <br />
      <br />
      = (Total Amount - (Transporter Advance + Freight Deduction + TDS Deduction))
      <br />= ({Number(total).toFixed(2)} - ({Number(advance).toFixed(2)} + {Number(freightDeduction).toFixed(2)} + {Number(tdsDeduction).toFixed(2)}) )
      <br />
      <strong> </strong> = ₹ {balance} /-
    </FormulaLayoutUI>
  );
};

export default TransporterBalanceAmount;
